import { render } from "./ClientPayment.vue?vue&type=template&id=a8125608&scoped=true"
import script from "./ClientPayment.vue?vue&type=script&lang=js"
export * from "./ClientPayment.vue?vue&type=script&lang=js"

import "./ClientPayment.vue?vue&type=style&index=0&id=a8125608&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8125608"]])

export default __exports__